(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/url-mapping/assets/javascripts/url-mapping.js') >= 0) return;  svs.modules.push('/components/utils/url-mapping/assets/javascripts/url-mapping.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.utils = svs.utils || {};
  svs.utils.urlMapping = svs.core.urlMapping;
})(svs);

 })(window);